import { ColumnType } from '@datachain/ui-sdk/components/dc-types';

export const HEADER_TYPES_COMPATIBILITY_MATRIX = new Map([
	['DETAILS', [ColumnType.Str]],
	[ColumnType.Unknown, [ColumnType.Str]],
	[ColumnType.Bool, [ColumnType.Bool, ColumnType.Str, ColumnType.Int]],
	[ColumnType.Date, [ColumnType.Date, ColumnType.Str, ColumnType.BigInt]],
	[ColumnType.Bin, [ColumnType.Bin]],
	[
		ColumnType.Dec,
		[ColumnType.Dec, ColumnType.Str, ColumnType.Int, ColumnType.BigInt],
	],
	[
		ColumnType.Str,
		[
			ColumnType.Str,
			ColumnType.Int,
			ColumnType.BigInt,
			ColumnType.Dec,
			ColumnType.Date,
			ColumnType.Bool,
		],
	],
	[
		ColumnType.Int,
		[
			ColumnType.Int,
			ColumnType.Str,
			ColumnType.BigInt,
			ColumnType.Dec,
			ColumnType.Bool,
		],
	],
	[
		ColumnType.BigInt,
		[
			ColumnType.BigInt,
			ColumnType.Str,
			ColumnType.Int,
			ColumnType.Dec,
			ColumnType.Bool,
			ColumnType.Date,
		],
	],
]);
